import { useEffect } from "react";
import { useDispatch } from "src/store";
import {setStep} from "src/store/bookingFlow";

export function useBookingFlowStep(myStep: number) {
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(setStep(myStep));
    },[dispatch, myStep])
}